import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {GLOBAL_MEASUREMENT_TYPES_QUERY_KEY} from '../../api/queries/getGlobalMeasurementTypes'
import {GlobalMeasurementType} from '../../types/GlobalMeasurementType'

import {useSettingsQuery} from '@settings/modules/common/providers'

export function useGlobalMeasurementTypesQuery(): UseQueryResult<GlobalMeasurementType[]> {
  const {t} = useTranslation()

  return useSettingsQuery(GLOBAL_MEASUREMENT_TYPES_QUERY_KEY, [], {
    meta: {
      errorMessage: t('measurementsSettings.queryError', {
        entity: 'Global Measurement Types'
      })
    }
  })
}
